import { colors, mediaFeatures, medPadding, stdPadding } from "./common";
import { splitColors } from "./splitColors";
export const selectFieldParent = `
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    user-select: none;
    margin-top: 0;
	margin-left: 0;
    @media screen and ${mediaFeatures["for-mobile"]} {
        margin-top: 4%;
    }
`;
export const selectFieldParentContent = `
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    height: 30px;
    width: 200px;
    margin-right: auto;
    margin-top: 0;
    @media screen and ${mediaFeatures["for-mobile"]} {
        margin-left: 0;
    }
    @media screen and ${mediaFeatures["for-pc"]} {
        margin-left: auto;
    }
`;
export const selectFieldParentHeader = `
    margin-right: 10px;
    margin-bottom: 0px;
    color: #999999;
    font-size: 14px;
    text-transform: uppercase;
    @media screen and ${mediaFeatures["for-mobile"]} {
        font-size: 9px;
    }
`;
export const downshiftParent = (isOpen = false) => `
    position: relative;
    ${isOpen ? "top: -15px;" : ""}
`;
export const selectField = `
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    cursor: pointer;
    height: 33px;
    max-width: 110px; 
    padding: 8px 7px;
    border: 1px solid ${colors["gray"]};
    border-radius: 50px;
    font-weight: normal;
    @media screen and ${mediaFeatures["for-pc"]} {
        height: 38px;
        max-width: 125px;
        padding: 9px 11px;
    }
`;
export const selectFieldInput = `
    cursor: pointer;
    border: none;
    width: 70px;
    @media screen and ${mediaFeatures["for-pc"]} {
        width: 80px;
    }
`;
export const selectFieldDropdown = `
    position: absolute;
    z-index: 1;
    cursor: pointer;
    width: 160px;
    padding: 0px;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.2);
    @media screen and ${mediaFeatures["for-pc"]} {
        width: 200px;
    }
    a + a {
        border-top: solid 1px #dddfe2;
    }
`;
export const selectFieldDropdownOption = `
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    height: 39px;
    list-style-type: none;
    color: #373435;
    font-size: 11px;
    font-weight: normal;
    @media screen and ${mediaFeatures["for-pc"]} {
        height: 47px;
        font-size: 14px;
    }
`;
export const selectFieldDropdownOptionContent = (active = false) => `
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: 100%;
    padding: 12px;
    color: #373435;
    font-weight: normal;
    ${active ? `color: ${colors["insiderRed"]}; font-weight: normal;` : ""}
`;
export const selectFieldDropdownOptionContentLeft = `
    display: flex;
    flex-flow: row nowrap;
    align-items: center;

    img {
        display: block;
        width: 100%;
        height: auto;
    }
`;
export const timeToggleList = `
    display: inline-block;
    vertical-align: bottom;
    padding: 0;
    margin-bottom: ${medPadding};
    position: relative;
    text-align: left;
    transition: all .5s ease-in-out;
    &::-webkit-scrollbar {
        -webkit-appearance: none !important;
        display: none !important;
        width: 0 !important;
        height: 0 !important;
    }
    @media screen and ${mediaFeatures["for-mobile-and-tablet"]} {
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        &::-webkit-scrollbar {
            -webkit-appearance: none;
            display: none;
            background-color: transparent;
            height: 0;
        }
        &::-webkit-scrollbar-thumb {
            display: none;
        }
        -webkit-overflow-scrolling: touch;
        }
    @media screen and ${mediaFeatures["for-large-tablet"]} {
        margin-bottom: ${stdPadding};
    }
`;
export const timeToggleListItem = `
    display: inline-block;
    list-style-type: none;
    margin-right: calc(${stdPadding} / 2);
    @media screen and ${mediaFeatures["for-tablet"]} {
        margin-right: ${medPadding};
    }
    @media screen and ${mediaFeatures["for-pc"]} {
        &:first-child{
            margin-left: 0;
        }
        &:last-child{
            margin-right: 0;
        }
    }
`;
export const timeToggleListItemHeader = `
    font-size: 14px;
    color: #999999;
    text-transform: uppercase;
    @media screen and ${mediaFeatures["for-mobile"]} {
        font-size: 9px;
    }
`;
export const timeToggleLink = `
    display: block;
    padding: calc(${stdPadding} / 2) ${medPadding};
    border: 1px solid ${colors["gray"]};
    border-radius: 50px;
    font-weight: 400;
    @media screen and ${mediaFeatures["for-pc"]} {
        padding: calc(${medPadding} - 2px) ${stdPadding};
    }
    &.active {
        color: rgb(255, 255, 255);
        background: ${splitColors["toggleActive"]};
        font-weight: 400;
        border-color: ${splitColors["toggleActive"]};
    }
`;
export const categoryToggleList = `
    white-space: nowrap;
    display: inline-block;
    vertical-align: bottom;
    padding: 0;
    margin-bottom: ${stdPadding};
    position: relative;
    text-align: left;
    transition: all .5s ease-in-out;
    &::-webkit-scrollbar {
        -webkit-appearance: none !important;
        display: none !important;
        width: 0 !important;
        height: 0 !important;
    }
    @media screen and ${mediaFeatures["for-mobile-and-tablet"]} {
        margin-bottom: ${medPadding};
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        &::-webkit-scrollbar {
            -webkit-appearance: none;
            display: none;
            background-color: transparent;
            height: 0;
        }
        &::-webkit-scrollbar-thumb {
            display: none;
        }
        -webkit-overflow-scrolling: touch;
    }
`;
export const categoryToggleListItem = `
    float: none;
    margin-right: calc(${stdPadding} / 2);
    display: inline-block;
    width: auto;
    height: auto;
    list-style-type: none;
    @media screen and ${mediaFeatures["for-pc"]} {
        margin-right: ${medPadding};
        &:last-child{
            margin-right: 0;
        }
    }
`;
export const categoryToggleListItemHeader = `
    font-size: 14px;
    color: #999999;
    margin-bottom: 0px;
    text-transform: uppercase;
    @media screen and ${mediaFeatures["for-mobile"]} {
        font-size: 9px;
    }
`;
export const categoryToggleLink = `
    ${timeToggleLink}
`;
